import Image from 'next/image'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {JSX} from 'react'
import {
	Icon as CIcon,
	type IconSize,
} from '@/products/flexible-web-toolkit/components/icon'
import {loadImageFromKontentAI} from '@/image-loader'
import type {Block} from '@/services/kontent-ai/types'
import {RichTextRenderer} from '@/products/flexible-web-toolkit/components/rich-text-renderer'
import {colorWithFallback} from '@/utilities/hooks/color-with-fallback'

export type IconWithTextContentItem = IContentItem<{
	icon: Elements.AssetsElement
	/** @deprecated Use brandColor instead */
	brand: Elements.MultipleChoiceElement
	brandColor: Elements.CustomElement
	iconSize: Elements.MultipleChoiceElement
	title: Elements.TextElement
	description: Elements.RichTextElement
	boldTitle: Elements.MultipleChoiceElement
}>

export const IconWithTextBlock: Block<IconWithTextContentItem> = ({
	block,
	page,
	...context
}): JSX.Element => {
	// Color priority: brandColor (new picker) → brand (deprecated dropdown) → page config → primary
	const {hexCode: iconBorderHex} = colorWithFallback({
		blockColor: block.elements.brandColor,
		blockColorLegacy: block.elements.brand,
		pageConfig: page.elements.config[0],
		fallbackColorId: 'primary',
	})

	return (
		<div className="flex items-start py-4">
			<CIcon
				borderHexColor={iconBorderHex ?? undefined}
				className="flex-shrink-0"
				size={
					(block.elements.iconSize[0]?.codename || 'lg') as IconSize
				}
			>
				<div className="relative h-full w-full">
					{block.elements.icon[0] ? (
						<Image
							alt={block.elements.icon[0].description ?? ''}
							fill
							loader={loadImageFromKontentAI}
							src={block.elements.icon[0].url}
						/>
					) : null}
				</div>
			</CIcon>
			<div className="ml-4">
				{block.elements.title ? (
					<strong
						className={
							block.elements.boldTitle[0]?.codename === 'bold'
								? 'font-bold'
								: 'font-normal'
						}
					>
						{block.elements.title}
					</strong>
				) : null}
				<RichTextRenderer
					element={block.elements.description}
					page={page}
					{...context}
				/>
			</div>
		</div>
	)
}
